// extracted by mini-css-extract-plugin
export default {"heading":"pl-z","createAccount":"ql-z","disabled":"rl-z","copy":"sl-z","terms":"tl-z"};